import React, { useState, useMemo, useEffect } from "react";

import { InputWithLabelAndError as Input } from "components/ui/InputWithLabelAndError";
import { Icon } from "@iconify/react";
import { ResponsiveDataTable } from "components/widgets/widgetTypes/tables/ResponsiveDataTable";

import { columnHeadersWithLabels, rolesWithLabels } from "data/translationArrays";
import ColumnFilterDropdown from "components/widgets/widgetTypes/tables/ColumnFilterDropdown";
import { toast } from "sonner";
import { DraggableTable } from "./Parcels/DraggableTable";
import { useStateContext } from "contexts/ContextProvider";
import {
  changeProjectUserMembership,
  loadProjectUsers,
  toCommunityUser,
  verifyProjectUserIdentity,
} from "helpers/projectUsers";
const roleLabelMap = new Map(
  rolesWithLabels.map((role) => [role.value, role.label])
);

const getRoleLabel = (roleValue) => {
  return roleLabelMap.get(roleValue) || roleValue; // Return the label or the original value if not found
};

const parcels = [
  {
    polygon_id: 1,
    parcel_id: 14,
    parcel_queue_id: 1,
    cadastre: 15,
    name: "Juan", // optional
  },
  {
    polygon_id: 1,
    parcel_id: 24,
    parcel_queue_id: 2,
    cadastre: 25,
    name: "Pedro", // optional
  },
]

const columnsConfig = [
  {
    id: "name",
    type: "sortable",
    header: "Nombre",
    accessorKey: "name",
  },
  {
    id: "lastName",
    type: "sortable",
    header: "Apellidos",
    accessorKey: "lastName",
  },
  {
    id: "team",
    type: "sortable",
    header: "Equipo",
    accessorKey: "team",
  },
  {
    id: "role",
    type: "sortable",
    header: "Rol",
    accessorKey: "role",
  },
  {
    id: "phone",
    type: "button",
    header: "Teléfono",
    accessorKey: "phone",
  },
  {
    id: "parcela",
    type: "sortable",
    header: "Parcela",
    accessorKey: "parcela",
  },
  {
    id: "actions",
    type: "actions",
    header: "Acciones",
    accessorKey: "actions",
    pin: "right",
  },
];

const Parcels = () => {
  const [searchTerm, setSearchTerm] = useState("");
  // const [filterOnline, setFilterOnline] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null); // Added state for selected profile
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [viewType, setViewType] = useState("list");
  const [tableColumns, setTableColumns] = useState([]); // Add state to manage columns
  const [userData, setUserData] = useState([]);
  // const [responseMessage, setResponseMessage] = useState("");
  //Load user's profile
  const { userProfile } = useStateContext();
  const storedUserProfile = userProfile;
  const currentProjectId = userProfile?.currentProjectId;
  const [isVerifyUserDialogOpen, setIsVerifyUserDialogOpen] = useState(false);

  const transformUserData = (data) => {
    return data.map((user) => toCommunityUser(user));
  };

  const fetchData = async () => {
    if (!currentProjectId) {
      setUserData([]);
      return;
    }

    try {
      const members = await loadProjectUsers(currentProjectId);
      setUserData(transformUserData(members));
    } catch (error) {
      console.error("Error fetching Project users:", error);
      toast.error(error.message || "No se han podido cargar los usuarios del proyecto.");
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentProjectId]);

  // const filteredUsers = useMemo(() => {
  //   //console.log("Community filteredUsers is running", userData);
  //   return userData.filter((user) => {
  //     const searchLower = searchTerm.toLowerCase();
  //     const firstName = user.contactDetails.firstName.toLowerCase();
  //     const lastName = user.contactDetails.lastName.toLowerCase();
  //     const team = user.contactDetails.team.toLowerCase();
  //     const role = user.role && user.role.toLowerCase();
  //     // Additional fields can be added here
  //     // const email = user.contactDetails.email.toLowerCase();

  //     return (
  //       firstName.includes(searchLower) ||
  //       lastName.includes(searchLower) ||
  //       team.includes(searchLower) ||
  //       role.includes(searchLower)
  //       // email.includes(searchLower) // Uncomment if email should be included in the search
  //     );
  //     // && (!filterOnline || user.isOnline);
  //   });
  // }, [searchTerm, userData]); //filterOnline
  // const uniqueTeams = [
  //   ...new Set(filteredUsers.map((user) => user.contactDetails.team)),
  // ];

  const handleViewProfile = (id) => {
    const selectedUser = userData.find((user) => user.id === id); // Ensure ID comparison as number
    setSelectedProfile(selectedUser);
    setSelectedProfileId(id);
  };

  const handleRowSelectionChange = (selectedRowId) => {
    // console.log("handleRowSelectionChange")
    const selectedUser = userData.find(
      (user) => user.id === parseInt(selectedRowId)
    ); // Ensure ID comparison as number
    // console.log("selectedRowId in handleRowSelectionChange", selectedRowId);
    if (!selectedRowId) return;
    setSelectedProfile(selectedUser);
    setSelectedProfileId(selectedRowId);
  };

  // const handleViewChange = (view, selectedRowId) => {
  //   setViewType(view);
  //   const selectedUser = userData.find(
  //     (user) => user.id === parseInt(selectedRowId)
  //   ); // Ensure ID comparison as number
  //   // console.log("selectedRowId in handleRowSelectionChange", selectedRowId);
  //   setSelectedProfile(selectedUser);
  //   setSelectedProfileId(selectedRowId);
  // };
  const handleViewChange = (view) => {
    setViewType(view);
  };

  const viewOptions = [
    { label: "Grid", value: "grid", icon: "bi:grid-fill" },
    { label: "Lista", value: "list", icon: "ri:table-fill" },
  ];

  const passedColumnsConfig = useMemo(() => {
    //console.log("Community columnsConfig in passedColumnsConfig", columnsConfig)
    return columnsConfig.map((column) => ({
      ...column,
      size: column.size && column.size ? column.size : null,
      pin: column.pin && column.pin ? column.pin : null,
      header: column.header,
      type: column.type,
      id: column.id,
      parcela: column.parcela,
      accessorKey: column.accessorKey,
    }));
  }, []);

  // const tableData = useMemo(() => {
  //   //console.log("Community tableData filteredUsers", filteredUsers);
  //   return filteredUsers.map((user) => ({
  //     id: user.id,
  //     image: {
  //       image: user.profilePicture,
  //       firstName: user.contactDetails.firstName,
  //       lastName: user.contactDetails.lastName,
  //       userName: user.username,
  //     },
  //     name: user.contactDetails.firstName,
  //     lastName: user.contactDetails.lastName,
  //     team: user.contactDetails.team,
  //     role: getRoleLabel(user.role),
  //     email: user.contactDetails.email,
  //     phone: user.contactDetails.phone,
  //   }));
  // }, [filteredUsers]);

  const editUser = async (selectedId) => {
    /* console.log("Community editUser id:", selectedId); */
    const selectedUser = userData.find((user) => user.id === selectedId); // Ensure ID comparison as number
    /* console.log("Community editUser selectedUser:", selectedUser); */
    // const userId = selectedProfile.selectedId;

    setSelectedProfile(selectedUser);
    setSelectedProfileId(selectedId);
    // Implement your user editing logic here
  };

  // const handleUserToVerify = async (selectedId) => {
  //   const selectedUser = userData.find((user) => user.id === selectedId); // Ensure ID comparison as number
  //   if (selectedUser.isVerified) {
  //     toast.success(`Usuario ${selectedUser} ya verificado`);
  //     return;
  //   }
  //   /* console.log("Community handleUserToVerify selectedUser", selectedUser); */

  //   setSelectedProfile(selectedUser);
  //   setSelectedProfileId(selectedId);

  //   setIsVerifyUserDialogOpen(true);
  // };

  const verifyUser = async (selectedProfile) => {
    if (!currentProjectId || !selectedProfile) return;
    try {
      const verUserRespond = await verifyProjectUserIdentity(currentProjectId, selectedProfile);
      console.log("Community verUser Respond: ", verUserRespond);
      toast.success(verUserRespond?.message || "Usuario verificado correctamente");
      await fetchData();
    } catch (error) {
      toast.error(error.message || "No se ha podido verificar la cuenta.");
    }
  };

  const verifyRole = async (selectedProfile) => {
    if (!currentProjectId || !selectedProfile) return;

    try {
      const verUserRoleRespond = await changeProjectUserMembership(currentProjectId, selectedProfile, {
        status: "approved",
      });
      console.log("Community verUserRole Respond: ", verUserRoleRespond);
      toast.success(verUserRoleRespond?.message || "Membresía aprobada correctamente");
      await fetchData();
    } catch (error) {
      toast.error(error.message || "No se ha podido actualizar la membresía.");
    }
  };

  const deleteUser = () => {
    if (!selectedProfile) return;
    const userId = selectedProfile.id;
    toast.error(`Usuario ${userId} eliminado correctamente`);
    //console.log("Community Delete user:", userId);
    // Implement your user deletion logic here
  };

  const handleVerifyUserSave = (updatedUser) => {
    // Handle user save logic here
    const selectedUser = userData.find(
      (user) => user.id === parseInt(updatedUser)
    ); // Ensure ID comparison as number
    setSelectedProfile(selectedUser);
    // You can use `updatedUser` to update the user data or make API calls
    setIsVerifyUserDialogOpen(false);
    toast.success("Usuario verificado correctamente");
  };

  useEffect(() => {
    console.log("selectedProfile", selectedProfile);
    console.log("selectedProfileId", selectedProfileId);
  }, [selectedProfile]);

  useEffect(() => {
    const updatedTableColumns = tableColumns.map((column) => {
      const columnLabel = columnHeadersWithLabels.find(
        (header) => header.value === column.id
      );
      return {
        ...column,
        label: columnLabel ? columnLabel.label : column.label,
      };
    });
  
    setTableColumns(updatedTableColumns);
    // console.log("Community useEffect tableColumns", updatedTableColumns);
  }, [tableColumns, columnHeadersWithLabels]);

  return (
    <div
      className={`relative z-0
        grid-cols-1 grid-rows-1
       h-full w-full gap-4`}>
      <div
        className={` @container/cmusers ${
          selectedProfile ? "-translate-x-full md:translate-x-0" : ""
        } transition-transform col-span-full row-span-full md:col-span-1 flex flex-col w-full gap-2`}>
        <div className="flex-row items-center justify-between w-full z-20 top-0 flex  px-px pt-px gap-x-4 gap-y-2">
          <Input
          variant="outline"
            type="search"
            placeholder="Filtrar por nombre, apellido, equipo..."
            onChange={(e) => setSearchTerm(e.target.value)}
            containerClassName="w-full max-w-sm focus-within:absolute @xl/cmusers:focus-within:relative focus-within:top-px @xl/cmusers:focus-within:top-0 focus-within:left-px @xl/cmusers:focus-within:left-0 focus-within:z-10 focus-within:w-[calc(100%_-_2px)] focus-within:max-w-full @xl/cmusers:focus-within:max-w-sm"
            className="w-8 focus:w-full px-1 @xl/cmusers:pr-2 @xl/cmusers:w-full"
          />
          <div className="flex gap-x-2">
            {viewType === "list" && (
              <ColumnFilterDropdown columns={tableColumns} />
            )}
          </div>
        </div>

        <div
          className={`flex relative h-[calc(100%_-_3rem)]  gap-4 w-full flex-col`}>
          
            <div className="h-full dashboard-widget p-1 md:p-2">
              {/* <DraggableTable 
              /> */}
              {/* <ResponsiveDataTable
                data={tableData}
                showHeaders={false}
                // filterFor="name"
                isEmptyMessage="Cargando usuarios..."
                columnsConfig={passedColumnsConfig}
                editUser={editUser}
                verifyUser={verifyUser} //handleUserToVerify
                verifyRole={verifyRole}
                deleteUser={deleteUser}
                // passedRowSelection={selectedProfileId}
                // setPassedRowSelection={setSelectedProfileId}
                // selectRow={handleSelectRow}
                setSelectedRow={setSelectedProfileId}
                enablePagination={false}
                enableRowSelection={true} // Enable row selection
                onRowSelectionChange={handleRowSelectionChange} // Pass the row selection handler
                singleRowSelection={true} // Enable single row selection
                setColumns={setTableColumns} // Pass the setColumns function
              /> */}
            </div>
        </div>
      </div>
    </div>
  );
};

export default Parcels;
